import { CurrencyTokenType as e } from "../../currency-lib/constants/currency.js";
var a = /* @__PURE__ */ ((n) => (n[n.IDLE = 0] = "IDLE", n[n.OPERATING = 1] = "OPERATING", n[n.SUCCESS = 2] = "SUCCESS", n[n.FAIL = 3] = "FAIL", n))(a || {}), t = /* @__PURE__ */ ((n) => (n.TRANSACTION_HASH = "TxnHash", n.REQUEST_ID = "RequestID", n))(t || {});
const r = {
  OrbitOwnerAttach: {
    type: "TxnHash",
    name: "StarOwnerAttachOwnPlanetSummary",
    eventName: "StarOwnerAttachOwnPlanetSummary"
  },
  OrbitOwnerDetach: {
    type: "TxnHash",
    name: "StarOwnerDetachPlanetSummary",
    eventName: "StarOwnerDetachPlanetSummary"
  },
  OrbitRenterAttach: {
    type: "TxnHash",
    name: "RentingOrbitalTrackSummary",
    eventName: "RentingOrbitalTrackSummary"
  },
  OrbitRenterDetach: {
    type: "TxnHash",
    name: "PlanetOwnerDetachPlanetSummary",
    eventName: "PlanetOwnerDetachPlanetSummary"
  },
  OrbitRenterRenew: {
    type: "TxnHash",
    name: "RenewRentingOrbitalTrackSummary",
    eventName: "RenewRentingOrbitalTrackSummary"
  },
  SeasonApostleMint: {
    type: "TxnHash",
    name: "SeasonApostleMint",
    eventName: "SeasonMintSummary"
  },
  TicketApostleMint: {
    type: "RequestID",
    name: "RequestTicketMinting",
    eventName: "RequestTicketMinting"
  },
  OrbitalTracksUpdated: {
    type: "TxnHash",
    name: "OrbitalTracksUpdated",
    eventName: "OrbitalTracksUpdated"
  },
  Vesting: {
    type: "TxnHash",
    name: "VestingReleased",
    eventName: "VestingReleased"
  },
  DailyCheckIn: {
    type: "TxnHash",
    name: "DailyCheckin",
    eventName: "DailyCheckin"
  },
  OrderCancelled: {
    type: "TxnHash",
    name: "OrderCancelled",
    eventName: "OrderCancelled"
  },
  OrderMatched: {
    type: "TxnHash",
    name: "OrderMatched",
    eventName: "OrderMatched"
  },
  MakeupCheckin: {
    type: "TxnHash",
    name: "MakeupCheckin",
    eventName: "MakeupCheckin"
  },
  ManagePlanetApostle: {
    type: "TxnHash",
    name: "ManageRelicApostlesSummary",
    eventName: "ManageRelicApostlesSummary"
  },
  CreateBounty: {
    type: "TxnHash",
    name: "CreateBounty",
    eventName: "CreateBounty"
  },
  CancelBounty: {
    type: "TxnHash",
    name: "CancelBounty",
    eventName: "CancelBounty"
  },
  FulfillBounty: {
    type: "TxnHash",
    name: "FulfillBounty",
    eventName: "FulfillBounty"
  },
  ApostleForgeSummary: {
    type: "TxnHash",
    name: "ApostleForgeSummary",
    eventName: "ApostleForgeSummary"
  },
  StakedToken: {
    type: "TxnHash",
    name: "StakedToken",
    eventName: "StakedToken"
  },
  UnstakedToken: {
    type: "TxnHash",
    name: "UnstakedToken",
    eventName: "UnstakedToken"
  },
  PurchaseSuccess: {
    type: "TxnHash",
    name: "PurchaseSuccess",
    eventName: "PurchaseSuccess"
  },
  TokenConverted: {
    type: "TxnHash",
    name: "TokenConverted",
    eventName: "TokenConverted"
  },
  SpiritualMerged: {
    type: "TxnHash",
    name: "SpiritualMerged",
    eventName: "SpiritualMerged"
  },
  ClaimedPrize: {
    type: "TxnHash",
    name: "ClaimedPrize",
    eventName: "ClaimedPrize"
  },
  PlanetChronomerged: {
    type: "TxnHash",
    name: "PlanetChronomerged",
    eventName: "PlanetChronomerged"
  }
}, s = 1e9, l = {
  [e.Anima]: 1e9,
  [e.AnimaRon]: 1e9,
  [e.Aprs]: 1e9,
  [e.AprsRon]: 1e9,
  [e.Usdc]: 1e9,
  [e.Weth]: 1e9,
  [e.WRon]: 1e9,
  [e.CAG]: 1e9,
  // no approval needed
  [e.Animus]: 0,
  [e.Aprm]: 0,
  [e.BlackHole]: 0,
  [e.Emblem]: 0,
  [e.Ron]: 0,
  [e.Stardust]: 0,
  [e.Unspecified]: 0
}, i = 5e10, T = 5e3, y = {
  APOSTLE_TICKET_MINT: "1000000",
  BREED: "1500000",
  BUY_ORDER: "800000",
  MORPH: "400000",
  VRF: "500000000000000000"
}, c = 2, h = 0.5;
export {
  s as AllowedErc20Limit,
  l as AllowedLimits,
  r as ContractEventParams,
  t as ContractEventType,
  a as ContractWorkStatus,
  T as DELAY_REFETCH_AFTER_CONTRACT_SUCCESS,
  i as GAS_FEE_PRIORITY,
  y as RONIN_GAS_LIMIT,
  h as RONIN_VRF_ESIMATE_FEE,
  c as RONIN_VRF_ESIMATE_MINUTES
};
//# sourceMappingURL=contract.js.map
